export function parseToParts(str: String) {
    let retParts = [];
    let pts = str.split(" ")
    pts.forEach((el: any) => {
        el.split(":").forEach((el1: any) => {
            el1.split("/").forEach((el2: any) => {
                retParts.push(el2 as never)
            })
        })
    })
    return retParts;
}

export function parseDate(dateVal: String, fmtStr: String) {
    let year = 1900;
    let month = 0;
    let day = 1;
    let hour = 0;
    let min = 0;
    let seconds = 0;
    let ampm = 'AM'
    let dateValParts = parseToParts(dateVal);
    let fmtStrParts: any = parseToParts(fmtStr);
    if (dateValParts.length != fmtStrParts.length) {
        return undefined;
    }
    for (let i = 0; i < dateValParts.length; i++) {
        let fmt = fmtStrParts[i];
        let fmtUpper = fmtStrParts[i].toUpperCase();
        let dt: any = dateValParts[i];
        if (fmtUpper == "YYYY") {
            year = +dt;
        } else if (fmtUpper == "YY") {
            year = +dt + 1900;
        } else if (fmt == "MM" || fmt == "M") {
            month = +dt;
        } else if (fmtUpper == "DD" || fmtUpper == "D") {
            day = +dt;
        } else if (fmtUpper == "HH" || fmtUpper == "H") {
            hour = +dt;
        } else if (fmt == "mm" || fmt == "m") {
            min = +dt;
        } else if (fmtUpper == "SS" || fmtUpper == "S") {
            seconds = +dt;
        } else if (fmtUpper == "AM" || fmtUpper == "PM" || fmtUpper == "AMPM" || fmtUpper == "AM/PM") {
            if (dt.toUpperCase() == "PM") {
                hour += 12;
            }
        }
    }
    return new Date(year, month - 1, day, hour, min, seconds);
}